import * as React from 'react'

function SvgCi(props) {
	return (
		<svg viewBox="0 0 450 300" width="1em" height="1em" {...props}>
			<path fill="#009E60" d="M0 0h450v300H0z" />
			<path fill="#FFF" d="M0 0h300v300H0z" />
			<path fill="#F77F00" d="M0 0h150v300H0z" />
		</svg>
	)
}

export default SvgCi
